import React, { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { toast } from "sonner";
import { Check, Clock, Send } from "lucide-react";
import { crearSolicitud, misSolicitudes } from "@/lib/api";
import { SOLICITUD_TIPOS, SOLICITUD_LABELS } from "@/data";

const fmt = (iso) => { try { return new Date(iso).toLocaleString("es-ES", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" }); } catch { return ""; } };

export default function Solicitudes() {
  const [tipo, setTipo] = useState("primer_cliente");
  const [mensaje, setMensaje] = useState("");
  const [sending, setSending] = useState(false);
  const { data: mias = [], refetch } = useQuery({ queryKey: ["misSolicitudes"], queryFn: misSolicitudes });

  const enviar = async () => {
    setSending(true);
    try {
      await crearSolicitud({ tipo, mensaje });
      toast.success("¡Solicitud enviada! El equipo Liberti se pondrá en contacto contigo.");
      setMensaje("");
      refetch();
    } catch (e) {
      toast.error("No se pudo enviar la solicitud. Inténtalo de nuevo.");
    } finally { setSending(false); }
  };

  return (
    <div data-testid="solicitudes">
      <div className="main-head">
        <div>
          <h1>Solicitudes</h1>
          <p className="sub">¿Listo para dar el paso? Elige qué necesitas y te acompañamos.</p>
        </div>
      </div>

      <div className="solic-hero" data-testid="solicitud-form">
        <label className="solic-label">¿Qué necesitas?</label>
        <div className="solic-tipos" data-testid="solicitud-tipos">
          {SOLICITUD_TIPOS.map(([id, ico, titulo, desc]) => (
            <button key={id} type="button" data-testid={`solicitud-tipo-${id}`}
              className={`solic-tipo ${tipo === id ? "on" : ""}`} onClick={() => setTipo(id)}>
              <span className="solic-tipo-ico" aria-hidden="true">{ico}</span>
              <span className="solic-tipo-txt"><b>{titulo}</b><span>{desc}</span></span>
              {tipo === id && <span className="solic-tipo-check"><Check size={14} /></span>}
            </button>
          ))}
        </div>

        <label className="solic-label" style={{ marginTop: 18 }}>Cuéntanos más (opcional)</label>
        <textarea
          value={mensaje}
          onChange={(e) => setMensaje(e.target.value)}
          placeholder="Ej: Ya domino la automatización con n8n y quiero empezar a vender. Mi nicho ideal serían pymes locales…"
          data-testid="solicitud-mensaje"
          className="solic-textarea"
        />
        <button className="btn btn-gold" onClick={enviar} disabled={sending} data-testid="solicitud-enviar">
          <Send size={16} /> {sending ? "Enviando…" : "Enviar solicitud"}
        </button>
      </div>

      {mias.length > 0 && (
        <div style={{ marginTop: 40 }}>
          <h3 className="serif" style={{ fontSize: 18, marginBottom: 14 }}>Tus solicitudes</h3>
          <div className="solic-list" data-testid="mis-solicitudes">
            {mias.map((s) => (
              <div className="solic-item" key={s.id} data-testid={`solicitud-${s.id}`}>
                <div className="solic-item-main">
                  <b>{SOLICITUD_LABELS[s.tipo] || "Solicitud"}</b>
                  {s.mensaje && <p>{s.mensaje}</p>}
                  {s.respuesta && (
                    <div className="solic-respuesta" data-testid={`solicitud-respuesta-${s.id}`}>
                      <span className="solic-respuesta-tag">Respuesta del equipo Liberti</span>
                      <p>{s.respuesta}</p>
                    </div>
                  )}
                  <span className="solic-date">{fmt(s.created_at)}</span>
                </div>
                <span className={`solic-badge ${s.estado === "atendida" ? "ok" : ""}`}>
                  {s.estado === "atendida" ? <><Check size={13} /> Atendida</> : <><Clock size={13} /> En revisión</>}
                </span>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
